import React, { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import shoppingCartService from '../../../../services/Public/shoppingCart.service';

function PaymentErrorPage() {
    const [hasFinished, setHasFinished] = useState(true);
    const push = useNavigate()
    var dispatch = useDispatch();
    var refreshToken = useSelector(x => x.refreshToken);
    useEffect(() => {

        dispatch({ type: "PERSIST_CURRENT_REFRESH", payload: refreshToken + 1 });


    }, [])
    const returnToDash = () => {
        push('/firm')
    }
    return (
        <>
            {hasFinished ?
                <Card>
                    <Card.Body style={{ textAlign: 'center' }}>
                        <>
                            <FaTimes style={{ height: '10em', width: '10em', color: '#EB0000' }} />
                            <h3 style={{ color: '#3980aa' }}>An Error has Occured</h3>
                            <h5 className="mb-3">There was an error trying to process your shopping cart. Please contact LAPELS to resolve this issue.</h5>
                            <Button onClick={returnToDash}>Back to Dashboard</Button>
                        </>
                    </Card.Body>
                </Card >
                : <></>
            }
        </>
    );
}

export default PaymentErrorPage;